// extracted by mini-css-extract-plugin
export default {"weekHeader":"WeekHeader_weekHeader__yrmZT"};